import { OnInit, Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { DialogService } from '../../../dialog/dialog.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { DashboardService } from '../../services/dashboard.service';
import { UtilService } from 'src/modules/base/services/util.service';
import * as CryptoJS from 'crypto-js';
import { PrintService } from 'src/modules/base/shared/services/print.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
declare var jQuery;

@Component({
    selector: 'dashboard-avighnaai',
    templateUrl: './avighnaai.component.html',
    styleUrls: ['./avighnaai.component.scss'],
    standalone: false
})
export class AvighnaAiComponent implements OnInit {
  @Input() data: any;
  controller:any;
  @Output() configChanged: EventEmitter<any> = new EventEmitter();
  
  config: any = {isPatient:true,isRefer:false};
  constructor(private baseService: BaseService, 
    private appService: AppService, 
    private auth: AuthenticationService, 
    private printService: PrintService, 
    private loader: LoaderService,
    public router: Router,
    public route: ActivatedRoute,
    public dialogService:DialogService,
    public storage: StorageService,
    public alerts: AlertsService,
    public utilService:UtilService,
    public dashBoardService:DashboardService
    ) {
  }

  ngOnInit() {
    console.log("this.data===>",this.data);
    this.controller = new AbortController();
    this.build();
  }

  handleResonse = (event:any) => {
    console.log("Message received from the child: " , event); // Message received from child
    const data = event.data;

      console.log("Message received from the child: " + JSON.stringify(data, null, 2));

      if (!data.error && data.specialties != undefined && data.specialties.length>0) {
          this.loader.showSpinner();
          var spl = data.specialties[0].name;
          var allSpl = this.getSpeciality();
          if(allSpl[spl.toLowerCase()] != undefined){
            var allSplName = this.getSpecialityName();
            //this.alerts.info("AI selected category is : "+allSplName[spl.toLowerCase()]);
            data["splCode"] = allSpl[spl.toLowerCase()];
            data["splName"] = allSplName[spl.toLowerCase()];
            this.uploadAiResult(data,(finalData)=>{
              this.storage.setData("ai_assessment",finalData,()=>{
                localStorage.setItem("ai_refer_speciality_code", data["splCode"]);
                var url = "/account-management/ai_assessment_result/";
                if(this.config.isRefer){
                  this.router.navigate([url],{queryParams:{is_refer:true,uhId:this.getUhid(),user_id:this.getUserID(),id:this.route.snapshot.params['id']}})
                }else{
                  this.router.navigate([url])
                }
                
              });
            })
           
            return;
          } 
        
        
      }else{
        if(data.error.message != undefined){
          this.alerts.error(data.error.message);
        }else{
          this.alerts.info("spl_error");
        }
      }
      if(this.config.isRefer){
        this.router.navigate(["/emr/patientlist_format/list"])
      }else{
        this.router.navigate(["/appointment/searchopd"])
      }
      
  }

  uploadAiResult(data,callback){
    if (!data.error && data.reportURL != undefined && data.reportURL) {
        
          var fileName = data.assessmentId;
          var reader = new FileReader();         
          reader.readAsDataURL(data.reportURL);
          reader.onloadend = () => {
            this.printService.uploadDownloadedData(data.reportURL, fileName+".pdf", "ai_assessment",null, this.getUserID(), 'application/pdf',(res)=>{
              var uHId = this.getUhid();
              let objectURL = URL.createObjectURL(data.reportURL);
              data.blob = objectURL;
              var obj = {"displayName":"","episode_id":"","encounter_id":"","uhId":uHId,"userId": this.getUserID(),"folder_name":"AI Assessment Report","description":"AI Generated Document : "+fileName ,"documentIds":[{"documentId":res.documentId}],"tag_data":[]}
              this.baseService.action(obj, "ADD", "emr", "file_document").subscribe(res => {})
              callback(data);
            });
          };       
          
     
    }else{
      this.loader.hideSpinner();
      callback(data)
    }
  }

  getAvighnaConfigs(callback){
    // let filter = "key:avighna_key#avighna_iv#avighna_url";
    this.baseService.get("GET_CREDENTIALS_AVIGHNA", "", "third_party_app_credentials", "system-management").subscribe(data => {
      if (data.errCode === 0) {
        try{
          var respData:any = {}
          respData["avighna_key"] = data.resource.find(e => e.key == "avighna_key").value
          respData["avighna_iv"] = data.resource.find(e => e.key == "avighna_iv").value
          respData["avighna_url"] = data.resource.find(e => e.key == "avighna_url").value
          callback(respData)
        }catch(e){
          this.alerts.error(e.error);
          console.error(e)
          callback(false)
        }
      } else {
        this.alerts.error(data.message);
        callback(false)
      }
    });
  }

  getUhid(){
    var uHId = this.route.snapshot.queryParams['uhId'];
    if(uHId == null){
      uHId = this.route.snapshot.params['uhId']; 
    }
    if(uHId == null){
      uHId = localStorage.getItem('hasUhId');
    }
    return uHId;
  }

  getUserID(){
    if (this.auth.getUserType() != "patient") {
        return this.config.user_id;
    }else{
      return this.baseService.authenticationService.getCurrentUser().user_id;
    }
  }
  build(){
    var uHId = this.getUhid();
    if(uHId != null){
      if(this.route.snapshot.params['is_refer'] && this.route.snapshot.params['is_refer'] == '1'){
        this.config.isRefer = true;
      }
      var datasource = {
        "application": "patient-registration",
        "resource": "patient",
        "query_id": "GET_PATIENT_DETAILS_BY_PATIENT_ID"
      };
      if (this.auth.getUserType() != "patient") {
        datasource["query_id"] = "GET_PATIENT_BY_UHID";
        datasource["args"] =  "uhId:" + uHId
        this.config.isPatient = false;
      }
      this.loader.showSpinner();
      this.getAvighnaConfigs((data)=>{
       
        this.baseService.getByDataSource(datasource).subscribe(
          (patientRespData: any) => {
            this.loader.hideSpinner();
            console.log("patientData",patientRespData);
            if (patientRespData.errCode == -1) {
              this.alerts.error("uhid_error")    
            } else {  
              var patientData = patientRespData.resource[0];
              this.config.user_id = patientData.id;  
              if(patientData.patient_age_in_milli != undefined && patientData.patient_gender != undefined && patientData.patient_name != undefined){
                data["patientAge"] = this.calculateAge(new Date(patientData.patient_age_in_milli))+""
                ;
                data["uHId"] = uHId;
                data["patientName"] = patientData.patient_name;
                data["patientGender"] = patientData.patient_gender.toUpperCase()
                ;
                this.config.data = data;
                console.log("config===>",this.config.data)
                this.config.url = this.encryptAvighna(data,data.avighna_iv,data.avighna_key,data.avighna_url);

                window.addEventListener('message', this.handleResonse,{signal:this.controller.signal,capture:true});
              }else{
                this.alerts.error("uhid_error");
              }
            }
        });
        
        
      })
    }else{
      this.alerts.error("uhid_error")
    }
    
  }

  encryptAvighna(data,ivString,key,url){
    var currentTime = new Date().getTime();

    var parsedBase64Key = CryptoJS.enc.Base64.parse(key);
    var assement = {      
    "userId": data['uHId'],    
    "patientName": data['patientName'],
    "patientAge": data['patientAge'],
    "patientGender":  data['patientGender'],
    "assessmentID": data['uHId']+"_"+currentTime,
    "expiryTime": currentTime + 1.8e+6//30mins in futture
    }
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(assement), parsedBase64Key,
    {
    iv: CryptoJS.enc.Base64.parse(ivString),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
    }
    );
    var e = encryptedData.toString();

    return url+"?frm=KARE_XPERT&assessmentinfo="+encodeURIComponent(e);
}

ngOnDestroy(){
  if(this.controller.abort != null){
    this.controller.abort();
  }
  window.removeEventListener('message', this.handleResonse,{capture:true});
}

calculateAge(birthday) { // birthday is a date
  var ageDifMs = Date.now() - birthday.getTime();
  var ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

getSpeciality(){
  
  return {
    'cardiologist' : '394579002',
    'cardiovascular and thoracic surgeon' : '408471009',
    'dentist' : '408444009',
    'dermatologist' : '394582007',
    'endocrinologist' : '394583002',
    'ent surgeon' :  'ear',
    'gastroenterologist' : '394584008',
    'general practitioner (m.b.b.s., md/dnb family medicine)' : '394802001',
    'general surgeon' : 'surgeon',
    'gynaecologist' : '394586005',
    'haematologist' : '394803006',
    'hepatologist' : '408472002',
    'nephrologist' : '394589003',
    'neurologist' : '394591006',
    'neurosurgeon' : '394610002',
    'oncologist' : '394592004',
    'ophthalmologist' : '394594003',
    'orthopaedic surgeon' : '394801008',
    'physician (md/dnb general medicine)' : '394802001',
    'psychiatrist' : '394587001',
    'pulmonologist' : '419170002',
    'rheumatologist' : '394810000',
    'urologist' : '394612005',
    'vascular surgeon' : '408463005'
    }
}

getSpecialityName(){
  
  return {
    'cardiologist' : 'Cardiology',
    'cardiovascular and thoracic surgeon' : 'Surgery-Cardiothoracic transplantation',
    'dentist' : 'Dental-General dental practice',
    'dermatologist' : 'Dermatology',
    'endocrinologist' : 'Endocrinology',
    'ent surgeon' :  'ENT',
    'gastroenterologist' : 'Gastroenterology',
    'general practitioner (m.b.b.s., md/dnb family medicine)' : 'General medicine',
    'general surgeon' : 'Surgeon',
    'gynaecologist' : 'Gynecology',
    'haematologist' : 'Clinical hematology',
    'hepatologist' : 'Hepatology',
    'nephrologist' : 'Nephrology',
    'neurologist' : 'Neurology',
    'neurosurgeon' : 'Surgery-Neurosurgery',
    'oncologist' : 'Clinical oncology',
    'ophthalmologist' : 'Ophthalmology',
    'orthopaedic surgeon' : 'Surgery-Trauma and orthopedics',
    'physician (md/dnb general medicine)' : 'General medicine',
    'psychiatrist' : 'Psychiatry',
    'pulmonologist' : 'Pediatric pulmonology',
    'rheumatologist' : 'Rheumatology',
    'urologist' : 'Urology',
    'vascular surgeon' : 'Surgery-Vascular'
    }
}
 
 
  
}
